import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/LoginRegister.css';
import USUARIO from '../assets/imagens/USUÁRIO.png';
import EMAIL from '../assets/imagens/EMAIL.png';
import SENHA from '../assets/imagens/SENHA.png';
import CONFIRMAR_SENHA from '../assets/imagens/CONFIRMAR_SENHA.png';
import CONTATO from '../assets/imagens/CONTATO.png';
const apiUrl = process.env.REACT_APP_API_URL;

function Register() {
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [contato, setContato] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.add('login-register-body');
    return () => {
      document.body.classList.remove('login-register-body');
    };
  }, []);

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (senha !== confirmarSenha) {
      setError('As senhas não coincidem');
      return;
    }

    const requestBody = { nome, email, senha, contato };
    console.log('Dados enviados:', requestBody);

    try {
      const response = await fetch(`${apiUrl}admins/registro`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        throw new Error('Registration failed');
      }

      const data = await response.json();
      console.log('Dados recebidos:', data);

      if (data.message === 'Conta criada com sucesso') {
        setSuccess('Conta criada com sucesso! Você será redirecionado para a página de login.');
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } else {
        setError('Registration failed');
      }
    } catch (error) {
      setError('An error occurred. Please try again.');
      console.log('Erro:', error);
    }
  };

  return (
    <div className="register-container">
      <h2>Cadastro</h2>
      <form onSubmit={handleRegister}>
        <div className="input-container">
          <img src={USUARIO} alt="usuario" className="input-icon" />
          <input type="text" value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Nome"/>
        </div>
        <div className="input-container">
          <img src={EMAIL} alt="email" className="input-icon" />
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email"/>
        </div>
        <div className="input-container">
          <img src={SENHA} alt="senha" className="input-icon" />
          <input type="password" value={senha} onChange={(e) => setSenha(e.target.value)} placeholder="Senha"/>
        </div>
        <div className="input-container">
          <img src={CONFIRMAR_SENHA} alt="confirmar senha" className="input-icon" />
          <input type="password" value={confirmarSenha} onChange={(e) => setConfirmarSenha(e.target.value)} placeholder="Confirme sua senha"/>
        </div>
        <div className="input-container">
          <img src={CONTATO} alt="contato" className="input-icon" />
          <input type="text" value={contato} onChange={(e) => setContato(e.target.value)} placeholder="Contato"/>
        </div>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        {success && <p style={{ color: 'green' }}>{success}</p>}
        <button type="submit">Cadastrar</button>
      </form>
      <button onClick={() => navigate('/login')}>Voltar</button>
    </div>
  );
}

export default Register;